import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import css from './UnderRowContent.css';
import CopyToClipboardButton from '../../../../../components/molecules/CopyToClipboardButton';

const TRANSLATION_PREFIX = 'STATIC.PAGES.MANAGE_LINKS.SUB_DOMAIN.TABLE.UNDER_ROW';

const UnderRowContent = ({ domain, showSDKInstructions = false, orgName, className, onVerifyClick, ...props }) => {
    const TARGET = `${orgName}.branded-domains.singular.net`;

    const renderSDKInstructions = () => {
        const codeAndroid = `SingularConfig Config = new SingularConfig(ApiKey, SecretKey)
.WithBrandedDomains(Arrays.AsList("${domain}"));`;
        const codeIOS = `SingularConfig* Config = [[SingularConfig Alloc]
InitWithApiKey:ApiKey AndSecret:SecretKey];
Config.BrandedDomains = @[@"${domain}"];`;
        return (
            <div className={css.sdkInstructions}>
                <h3 className={css.sdkTitle}>
                    <Translate id={`${TRANSLATION_PREFIX}.SDK.TITLE`} />
                </h3>
                <p className={css.sdkDescription}>
                    <Translate id={`${TRANSLATION_PREFIX}.SDK.DESCRIPTION`} />
                    <a href="#" className={css.learnMoreLink}>
                        <Translate id={`${TRANSLATION_PREFIX}.SDK.LEARN_MORE`} />
                    </a>
                </p>

                <div className={css.sdkPlatforms}>
                    <div className={css.platform}>
                        <h4 className={css.platformTitle}>
                            <Translate id={`${TRANSLATION_PREFIX}.SDK.IOS_TITLE`} />
                        </h4>
                        <div className={css.codeContainer}>
                            <pre className={css.codeBlock}>
                                <div className={css.codeHeader}>
                                    <span className={css.codeLanguage}>Objective-C</span>
                                    <CopyToClipboardButton textToCopy={codeIOS} />
                                </div>
                                <code>{codeIOS}</code>
                            </pre>
                        </div>
                    </div>

                    <div className={css.platform}>
                        <h4 className={css.platformTitle}>
                            <Translate id={`${TRANSLATION_PREFIX}.SDK.ANDROID_TITLE`} />
                        </h4>
                        <div className={css.codeContainer}>
                            <pre className={css.codeBlock}>
                                <div className={css.codeHeader}>
                                    <span className={css.codeLanguage}>Java</span>
                                    <CopyToClipboardButton textToCopy={codeAndroid} />
                                </div>
                                <code>{codeAndroid}</code>
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderDnsSetupInstruction = () => (
        <div className={css.mainContent}>
            <h2 className={css.title}>
                <Translate id={`${TRANSLATION_PREFIX}.SETUP.TITLE`} />
            </h2>

            <p className={css.description}>
                <Translate id={`${TRANSLATION_PREFIX}.SETUP.DESCRIPTION`} data={{ domain }} />
            </p>

            <div className={css.steps}>
                <div className={css.step}>
                    <h3 className={css.stepTitle}>
                        <span className={css.stepNumber}>
                            1. <Translate id={`${TRANSLATION_PREFIX}.SETUP.STEP1_TITLE`} />
                        </span>
                    </h3>

                    <div className={css.dnsTable}>
                        <div className={css.tableGrid}>
                            <div className={css.tableCell}>
                                <span className={css.label}>
                                    <Translate id={`${TRANSLATION_PREFIX}.SETUP.TYPE_LABEL`} />
                                </span>
                            </div>
                            <div className={css.tableCell}>
                                <span className={css.label}>
                                    <Translate id={`${TRANSLATION_PREFIX}.SETUP.HOSTNAME_LABEL`} />
                                </span>
                            </div>
                            <div className={css.tableCell} />
                        </div>

                        <div className={css.tableGrid}>
                            <div className={css.tableCell}>
                                <span className={css.value}>CNAME</span>
                            </div>
                            <div className={css.tableCellCopy}>
                                <span className={css.value}>{domain}</span>
                                <CopyToClipboardButton textToCopy={domain} />
                            </div>
                        </div>

                        <div className={css.tableRow}>
                            <div className={css.tableCell}>
                                <span className={css.label}>
                                    <Translate id={`${TRANSLATION_PREFIX}.SETUP.TARGET_LABEL`} />
                                </span>
                            </div>
                            <div className={css.tableCellCopy}>
                                <span className={css.value}>{TARGET}</span>
                                <CopyToClipboardButton textToCopy={TARGET} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={css.step}>
                    <h3 className={css.stepTitle}>
                        <span className={css.stepNumber}>
                            2. <Translate id={`${TRANSLATION_PREFIX}.SETUP.STEP2_TITLE`} />
                        </span>
                    </h3>
                    <p className={css.stepDescription}>
                        <Translate id={`${TRANSLATION_PREFIX}.SETUP.STEP2_DESCRIPTION`} />
                    </p>
                </div>

                <div className={css.step}>
                    <h3 className={css.stepTitle}>
                        <span className={css.stepNumber}>
                            3. <Translate id={`${TRANSLATION_PREFIX}.SETUP.STEP3_TITLE`} />
                        </span>
                    </h3>
                    <p className={css.stepDescription}>
                        <Translate id={`${TRANSLATION_PREFIX}.SETUP.STEP3_DESCRIPTION`} />
                    </p>
                </div>
            </div>
        </div>
    );

    return (
        <div className={classNames(css.underRowContent, className)} {...props}>
            {!showSDKInstructions ? renderDnsSetupInstruction() : renderSDKInstructions()}
        </div>
    );
};

UnderRowContent.propTypes = {
    domain: PropTypes.string.isRequired,
    showSDKInstructions: PropTypes.bool,
    className: PropTypes.string,
    orgName: PropTypes.string,
    onVerifyClick: PropTypes.func,
};

UnderRowContent.defaultProps = {
    showSDKInstructions: false,
    className: '',
    onVerifyClick: null,
};

export default UnderRowContent;
